import apiClient from './client'

export interface LibraryItem {
  paper_ref: string
  title: string
  authors: string[]
  year?: number
  doi?: string
  pmid?: string
  arxiv_id?: string
  abstract?: string
  venue?: string
  url?: string
  isOpenAccess?: boolean
  citationCount?: number
  referenceCount?: number
  fieldsOfStudy?: string[]
  added_at?: string
  tags?: string[]
  notes?: string | null
  added_from_type?: string | null
  added_from_id?: string | null
}

export interface ListLibraryParams {
  search?: string
  tags?: string
  year_from?: number
  year_to?: number
  limit?: number
  offset?: number
}

export interface CreateManualLibraryItemPayload {
  title: string
  authors?: string[]
  abstract?: string
  year?: number
  venue?: string
  doi?: string
  pmid?: string
  arxiv_id?: string
  url?: string
  tags?: string[]
  notes?: string
}

export const userLibraryAPI = {
  async listLibrary(params?: ListLibraryParams): Promise<LibraryItem[]> {
    return apiClient.get<LibraryItem[]>('/api/user/library', params)
  },

  async addManualItem(payload: CreateManualLibraryItemPayload): Promise<LibraryItem> {
    return apiClient.post<LibraryItem>('/api/user/library', payload)
  },
}

export default userLibraryAPI


